import {CanActivateFn, Router} from '@angular/router';
import {TableNumberService} from "../http/table-number.service";
import {inject} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {OrderService} from "../http/order.service";

export const orderGuard: CanActivateFn = (route, state) => {

  const tableNumberService = inject(TableNumberService);
  const orderService = inject(OrderService);
  const router = inject(Router);
  const _snackBar = inject(MatSnackBar);

  const orderFromState = sessionStorage.getItem('orderState');
  const tableNumberFromState = sessionStorage.getItem('tableNumberState');

  if (tableNumberFromState && orderFromState) {
    tableNumberService.setTableNumber(JSON.parse(tableNumberFromState).tableNumber);
    orderService.setOrder(JSON.parse(orderFromState).order);
  }

  if (tableNumberService.getTableNumber() === '' && !tableNumberService.getVoucher() && !orderService.getOrder()) {
    _snackBar.open('Bitte zuerst Tischnummer eingeben', 'Schließen', {duration: 3000});
    return router.parseUrl('/tablenumber');
  } else {
    return true;
  }

};
